/**
 * The game modes the engine ships, registered by id with a loader, so each
 * mode's code is its own chunk and downloads only when a level uses it.
 */
import type { GameModeRegistry } from "./GameModeRegistry";
import { GM_SHOWCASE } from "./modeIds";

export function registerGameModes(registry: GameModeRegistry): void {
  registry.register(GM_SHOWCASE, () => import("./showcase").then((mode) => mode.showcaseModule));
}
